import React, { useState } from "react";
import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";

const CameraCapture = () => {
  const [image, setImage] = useState(null);
  const [base64Image, setBase64Image] = useState(null);
  const [uploading, setUploading] = useState(false);

  const takePhoto = async () => {
    try {
      const photo = await Camera.getPhoto({
        quality: 90,
        source: CameraSource.Camera, // Opens camera
        resultType: CameraResultType.Base64 // Gets image as Base64
      });

      if (photo.base64String) {
        const imageUrl = `data:image/jpeg;base64,${photo.base64String}`;
        setImage(imageUrl); // Display image preview
        setBase64Image(photo.base64String); // Store base64 for upload
      }
    } catch (error) {
      console.error("Camera Error:", error);
    }
  };

  const uploadImage = async () => {
    if (!base64Image) {
      alert("Please take a photo first!");
      return;
    }

    setUploading(true);
    try {
      const response = await fetch("https://your-api.com/upload", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ image: base64Image }),
      });

      if (!response.ok) throw new Error("Upload failed");

      alert("Image uploaded successfully!");
    } catch (error) {
      console.error("Upload Error:", error);
      alert("Upload failed. Try again.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      <h2>📸 Capture & Upload Photo</h2>
      
      <button onClick={takePhoto} disabled={uploading}>
        Capture Photo
      </button>

      {/* Display image immediately after capture */}
      {image && (
        <div style={{ marginTop: "20px" }}>
          <h3>Preview:</h3>
          <img
            src={image}
            alt="Captured"
            style={{ width: "250px", borderRadius: "10px", border: "2px solid #ccc" }}
          />
          <br />

          {/* Upload Button */}
          <button onClick={uploadImage} disabled={uploading} style={{ marginTop: "10px" }}>
            {uploading ? "Uploading..." : "Upload Image"}
          </button>
        </div>
      )}
    </div>
  );
};

export default CameraCapture;